import { RequestMethod } from '../../enums/request-method';
import { IRestRequest } from '../../interfaces/rest/rest-request';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a ShopifyWebhook task.
 * Entry trigger that receives Shopify webhook events, validates the HMAC-SHA256
 * signature, and starts the flow for each incoming event.
 * httpMethod, endpoint, url, and isSync are managed by the flow engine.
 */
export class ShopifyWebhookConfig extends DestinationTaskConfigBase {
	httpMethod = RequestMethod.GET;
	endpoint = '';
	url = '';
	isSync = false;
	sampleData?: IRestRequest;
	/** Shopify app client secret used to verify the HMAC-SHA256 webhook signature. @default '' */
	clientSecret = '';

	constructor(init?: Partial<ShopifyWebhookConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
